/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCatalog200ResponseCategoriesInnerProductsInner } from './GetCatalog200ResponseCategoriesInnerProductsInner';
import {
    GetCatalog200ResponseCategoriesInnerProductsInnerFromJSON,
    GetCatalog200ResponseCategoriesInnerProductsInnerFromJSONTyped,
    GetCatalog200ResponseCategoriesInnerProductsInnerToJSON,
    GetCatalog200ResponseCategoriesInnerProductsInnerToJSONTyped,
} from './GetCatalog200ResponseCategoriesInnerProductsInner';

/**
 * 
 * @export
 * @interface GetCatalog200ResponseCategoriesInner
 */
export interface GetCatalog200ResponseCategoriesInner {
    /**
     * 
     * @type {string}
     * @memberof GetCatalog200ResponseCategoriesInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetCatalog200ResponseCategoriesInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetCatalog200ResponseCategoriesInner
     */
    catalogId: string;
    /**
     * 
     * @type {string}
     * @memberof GetCatalog200ResponseCategoriesInner
     */
    source?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCatalog200ResponseCategoriesInner
     */
    externalId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetCatalog200ResponseCategoriesInner
     */
    position: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetCatalog200ResponseCategoriesInner
     */
    enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCatalog200ResponseCategoriesInner
     */
    description: string;
    /**
     * 
     * @type {Array<GetCatalog200ResponseCategoriesInnerProductsInner>}
     * @memberof GetCatalog200ResponseCategoriesInner
     */
    products: Array<GetCatalog200ResponseCategoriesInnerProductsInner>;
}

/**
 * Check if a given object implements the GetCatalog200ResponseCategoriesInner interface.
 */
export function instanceOfGetCatalog200ResponseCategoriesInner(value: object): value is GetCatalog200ResponseCategoriesInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('catalogId' in value) || value['catalogId'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('products' in value) || value['products'] === undefined) return false;
    return true;
}

export function GetCatalog200ResponseCategoriesInnerFromJSON(json: any): GetCatalog200ResponseCategoriesInner {
    return GetCatalog200ResponseCategoriesInnerFromJSONTyped(json, false);
}

export function GetCatalog200ResponseCategoriesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCatalog200ResponseCategoriesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'catalogId': json['catalogId'],
        'source': json['source'] == null ? undefined : json['source'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'position': json['position'],
        'enabled': json['enabled'],
        'description': json['description'],
        'products': ((json['products'] as Array<any>).map(GetCatalog200ResponseCategoriesInnerProductsInnerFromJSON)),
    };
}

export function GetCatalog200ResponseCategoriesInnerToJSON(json: any): GetCatalog200ResponseCategoriesInner {
    return GetCatalog200ResponseCategoriesInnerToJSONTyped(json, false);
}

export function GetCatalog200ResponseCategoriesInnerToJSONTyped(value?: GetCatalog200ResponseCategoriesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'catalogId': value['catalogId'],
        'source': value['source'],
        'externalId': value['externalId'],
        'position': value['position'],
        'enabled': value['enabled'],
        'description': value['description'],
        'products': ((value['products'] as Array<any>).map(GetCatalog200ResponseCategoriesInnerProductsInnerToJSON)),
    };
}

